import cookie, { type SerializeOptions as CookieSerializeOptions } from 'cookie';

function decodeCookieValue(value: unknown): unknown {
  if (typeof value === 'string') {
    try {
      return JSON.parse(value);
    } catch {
      // fail silently
    }
  }

  return value;
}

export function getCookies() {
  if (typeof document === 'undefined') {
    return {};
  }
  return cookie.parse(document.cookie);
}

export function getCookie(key: string) {
  const cookies = getCookies();
  return decodeCookieValue(cookies[key]);
}

export function setCookie(key: string, value: string, options: CookieSerializeOptions = { path: '/' }) {
  const serializedCookie = cookie.serialize(key, value, options);
  if (typeof document !== 'undefined') {
    // oxlint-disable-next-line unicorn/no-document-cookie -- TODO: change how this works?
    document.cookie = serializedCookie;
  }
}

export function removeCookie(key: string, options: CookieSerializeOptions = { path: '/' }) {
  setCookie(key, '', { ...options, maxAge: 0 });
}
